import React from 'react'
import Footer from '../footer/Footer'
import Navbar from '../Navbar'
import MyprofileHook from './MyprofileHook';

const Myprofile = () => {
    const {userDetail } =MyprofileHook()

    const formatDateForInput = (date) => {
        if (!date || typeof date !== "string") {
          return "";
        }
        const [day, month, year] = date.split("-");
        return `${year}-${month}-${day}`;
      };
      
    return (
        <div>
            <div>
                <Navbar />
                <div className='pt-3 innerBg'>
                    <h1 style={{ color: 'white', fontWeight: '600' }}>My Profile</h1>
                </div>
                <div className='py-5 my-3'>
                    <div className='querycard'>
                        <h1 className='text-center'><strong>Profile Details</strong></h1>
                        <div className='d-flex'>
                            {/* <div>
                                <img src={userDetail.image} className='userimg2' />
                            </div> */}
                            <div>
                                <p><strong>{userDetail.name}</strong></p>
                                <p>{userDetail.email}</p>
                            </div>
                        </div>
                        <div className='my-5'>
                            <div className='row py-3'>
                                <div className='col'>
                                    <label for="name">Full Name</label>
                                    <input type="text" className="form-control" value={userDetail.name}/>
                                </div>

                                <div className='col'>
                                    <label for="dob">Date of Birth</label>
                                    <input type="date" className="form-control" value={formatDateForInput(userDetail.dateofbirth)} />
                                </div>
                            </div>
                            <div className='row py-3'>
                                <div className='col'>
                                    <label for="password">Password</label>
                                    <input type="password" className="form-control" value={userDetail.password} />
                                </div>

                                <div className='col '>
                                    <label for="email">Center</label>
                                    <input type="text" className="form-control" value={userDetail.center} />
                                </div>
                            </div>
                            <div className='row py-3'>
                                <div className='col'>
                                    <label for="email">Batch</label>
                                    <input type="text" className="form-control"  value={userDetail.batch_code}  />
                                </div>

                                <div className='col'>
                                    <label for="email">CAT Year</label>
                                    <input type="number" className="form-control"  value={userDetail.catyear}  />
                                </div>
                            </div>
                            <div className='row py-3'>
                                <div className='col'>
                                    <label for="email">Mobile Number</label>
                                    <input type="tel" className="form-control"  value={userDetail.mobile}  />
                                </div>

                                <div className='col'>
                                    <label for="email">Email Id</label>
                                    <input type="email" className="form-control"  value={userDetail.email}  />
                                </div>
                            </div>
                            <div className='row py-3'>
                                <div className='col'>
                                    <label for="email">Admission Date</label>
                                    <input type="date" className="form-control" value={formatDateForInput(userDetail.admissiondate)} />
                                </div>

                                <div className='col'>
                                    <label for="email">Address</label>
                                    <input type="email" className="form-control" value={userDetail.address} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Myprofile
